import { Navigate, Outlet } from "react-router-dom";

import { useAuthentication } from "../../services/authentication/authentication.context";

const ProtectedRoute = () => {

  
    const { isAuthenticated } = useAuthentication();

    return (
             isAuthenticated === false  ?  <Navigate to="/enteradmin" /> : <Outlet /> 
           );
  
};

export default ProtectedRoute;